/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLandlordSlaRequestDto
 */
export interface UpdateLandlordSlaRequestDto {
    /**
     * 
     * @type {number}
     * @memberof UpdateLandlordSlaRequestDto
     */
    uptimeTargetPct?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLandlordSlaRequestDto
     */
    responseDcDays?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLandlordSlaRequestDto
     */
    responseAcDays?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateLandlordSlaRequestDto
     */
    penaltyPerDayAmount?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordSlaRequestDto
     */
    penaltyCurrency?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordSlaRequestDto
     */
    paymentModel?: UpdateLandlordSlaRequestDtoPaymentModelEnum;
    /**
     * 
     * @type {Date}
     * @memberof UpdateLandlordSlaRequestDto
     */
    validFrom?: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateLandlordSlaRequestDto
     */
    validTo?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordSlaRequestDto
     */
    status?: UpdateLandlordSlaRequestDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateLandlordSlaRequestDto
     */
    notes?: string;
}


/**
 * @export
 */
export const UpdateLandlordSlaRequestDtoPaymentModelEnum = {
    Annual: 'ANNUAL',
    Monthly: 'MONTHLY',
    PerCp: 'PER_CP'
} as const;
export type UpdateLandlordSlaRequestDtoPaymentModelEnum = typeof UpdateLandlordSlaRequestDtoPaymentModelEnum[keyof typeof UpdateLandlordSlaRequestDtoPaymentModelEnum];

/**
 * @export
 */
export const UpdateLandlordSlaRequestDtoStatusEnum = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Expired: 'EXPIRED'
} as const;
export type UpdateLandlordSlaRequestDtoStatusEnum = typeof UpdateLandlordSlaRequestDtoStatusEnum[keyof typeof UpdateLandlordSlaRequestDtoStatusEnum];


/**
 * Check if a given object implements the UpdateLandlordSlaRequestDto interface.
 */
export function instanceOfUpdateLandlordSlaRequestDto(value: object): value is UpdateLandlordSlaRequestDto {
    return true;
}

export function UpdateLandlordSlaRequestDtoFromJSON(json: any): UpdateLandlordSlaRequestDto {
    return UpdateLandlordSlaRequestDtoFromJSONTyped(json, false);
}

export function UpdateLandlordSlaRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLandlordSlaRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'uptimeTargetPct': json['uptimeTargetPct'] == null ? undefined : json['uptimeTargetPct'],
        'responseDcDays': json['responseDcDays'] == null ? undefined : json['responseDcDays'],
        'responseAcDays': json['responseAcDays'] == null ? undefined : json['responseAcDays'],
        'penaltyPerDayAmount': json['penaltyPerDayAmount'] == null ? undefined : json['penaltyPerDayAmount'],
        'penaltyCurrency': json['penaltyCurrency'] == null ? undefined : json['penaltyCurrency'],
        'paymentModel': json['paymentModel'] == null ? undefined : json['paymentModel'],
        'validFrom': json['validFrom'] == null ? undefined : (new Date(json['validFrom'])),
        'validTo': json['validTo'] == null ? undefined : (new Date(json['validTo'])),
        'status': json['status'] == null ? undefined : json['status'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateLandlordSlaRequestDtoToJSON(json: any): UpdateLandlordSlaRequestDto {
    return UpdateLandlordSlaRequestDtoToJSONTyped(json, false);
}

export function UpdateLandlordSlaRequestDtoToJSONTyped(value?: UpdateLandlordSlaRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uptimeTargetPct': value['uptimeTargetPct'],
        'responseDcDays': value['responseDcDays'],
        'responseAcDays': value['responseAcDays'],
        'penaltyPerDayAmount': value['penaltyPerDayAmount'],
        'penaltyCurrency': value['penaltyCurrency'],
        'paymentModel': value['paymentModel'],
        'validFrom': value['validFrom'] == null ? value['validFrom'] : value['validFrom'].toISOString(),
        'validTo': value['validTo'] == null ? value['validTo'] : value['validTo'].toISOString(),
        'status': value['status'],
        'notes': value['notes'],
    };
}

